/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useMotionValue as o}from"./use-motion-value.js";import{cancelFrame as r,frame as t}from"../frameloop/index.js";import{useIsomorphicLayoutEffect as e}from"../utils/use-isomorphic-effect.js";function m(m,n){const s=o(n()),i=()=>s.set(n());return i(),e((()=>{const o=()=>t.update(i,!1,!0),e=m.map((r=>r.on("change",o)));return()=>{e.forEach((o=>o())),r(i)}})),s}export{m as useCombineMotionValues};
//# sourceMappingURL=use-combine-values.js.map
